export default __webpack_public_path__ + "static/media/bundle-guide-me-us-white@3x.2df011c8.webp";